import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

/**
 * Text field for forms using react-hook-form.
 *
 * @param control: react-hook-form control object
 */

interface IFormTextFieldProps {
  name: string;
  control: any;
  label: string;
  style?: any;
  readOnly?: boolean;
}

const FormTextField = (props: IFormTextFieldProps) => {
  const { style, name, control, label, readOnly } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          data-testid={label}
          error={!!error}
          onChange={onChange}
          value={value ?? ""}
          fullWidth
          label={label}
          variant="outlined"
          sx={{
            ...style,
            color: "secondary.light",
          }}
          inputProps={{ readOnly: readOnly || false }}
        />
      )}
    />
  );
};

export default FormTextField;
